module.exports = __webpack_public_path__ + "img/login-img.270e2c12.svg";